import { render } from "./HospitalInfoW.vue?vue&type=template&id=1070ac34"
import script from "./HospitalInfoW.vue?vue&type=script&lang=js"
export * from "./HospitalInfoW.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__